import React from "react";
import { reviewData } from "../../data";

export default function AllReview() {
  return (
    <>
      <section className="customer-review-section ptb-100 gray-light-bg">
        <div className="container">
          <div className="row">
            {reviewData.map((review) => (
              <div className="col-md-6 col-sm-6 col-lg-6" key={review.id}>
                <div className="testimonial-quote-wrap my-lg-3 my-md-3 rounded white-bg shadow-sm p-5">
                  <div className="client-say">
                    <h2 style={{fontSize:'20px'}}>{review.header}</h2>
                    <p>
                     
                      {review.quote}
                    </p>
                  </div>
                  <div className="media author-info mb-3">
                 
                      
                    
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
